// src/i18n/en/cv/experience.ts

export const EXPERIENCE = {
  // Hewlett Packard Enterprise — Software Engineering
  TFD_JOB_NAME: 'Hewlett Packard Enterprise — Software Engineering',
  TFD_JOB_LENGTH: 'Jan 2025',
  TFD_JOB_DESCRIPTION:
    'Completed a hands-on job simulation focused on scalable system design, debugging, and Agile collaboration. Built production-level modules, optimized backend logic, and improved code quality through peer reviews and CI/CD practices.',

  // Deloitte Australia — Technology
  LBS_JOB_NAME: 'Deloitte Australia — Technology',
  LBS_JOB_LENGTH: 'Jan 2025',
  LBS_JOB_DESCRIPTION:
    'Worked on a consulting-based technology simulation emphasizing business solution design, process automation, and data-driven decision systems. Designed tech-driven strategies to enhance efficiency and impact.',

  // Mastercard — Cybersecurity
  GRAL_JOB_NAME: 'Mastercard — Cybersecurity',
  GRAL_JOB_LENGTH: 'Jan 2025',
  GRAL_JOB_DESCRIPTION:
    'Completed an immersive cybersecurity simulation focusing on secure coding, data protection, and risk analysis. Developed incident response workflows and implemented defense-in-depth strategies to ensure system resilience.',

  // Electronic Arts — Software Engineering
  QWERTY_JOB_NAME: 'Electronic Arts — Software Engineering',
  QWERTY_JOB_LENGTH: 'Jan 2025',
  QWERTY_JOB_DESCRIPTION:
    'Participated in a game-tech inspired software engineering simulation. Built real-time applications with an emphasis on performance, scalability, teamwork, and version control best practices.',
};
